/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-01-19 19:47:37
 */

import * as Vue from 'vue-tsx-support';
import { Component, Prop } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import Modal from 'src/types/iview/Modal';
import { modalFactory } from 'src/util/vueExtend';
import { Integer } from 'src/types/base';
import { createBEM } from 'src/util/bem';
import './auditRuleViewModal.less';
import AgGridVueCustomTsx, { ColDefCustom } from 'src/components/agGridCustom/agGridVueCustomTsx';
import { GridOptions } from 'ag-grid-community';
import DataAuditApi from './api/dataAuditApi';
import Button from '../../../types/iview/Button';
import auditAddInvalidModal from './auditAddInvalidModal';
import { Toast } from '../../../util/toast';
let bem = createBEM('audit-rule-view');

export namespace AuditRuleViewVOI {
    export interface PropsI {
        saveSuccess?(): void;
        cancel?(): void;
    }

    export interface FormDataI {
        id?: Integer;
        code: string;
        name: any;
        priority_level: string;
    }
}

@Component
class AuditRuleViewModal extends Vue.Component<AuditRuleViewVOI.PropsI> {
    @Prop({
        type: Function,
    })
    cancel!: () => void;

    @Prop({
        type: Function,
    })
    saveSuccess!: () => void;

    visible: boolean = false;

    currentTab = '无效标识集';
    // 附件相关的表格
    gridOptions: GridOptions = {};

    dataSource: any = {
        无效标识集: [],
    };

    get columnDefs(): ColDefCustom[] {
        let cols: ColDefCustom[] = [];
        switch (this.currentTab) {
            case '无效标识集':
                cols = [
                    {
                        headerName: '标识代码',
                        field: 'code',
                        minWidth: 100,
                    },
                    {
                        headerName: '标识名称',
                        field: 'name',
                        minWidth: 100,
                    },
                    {
                        headerName: '优先级别',
                        field: 'priority_level',
                        minWidth: 100,
                    },
                ];
        }
        return cols;
    }

    rowData: any[] = [];

    close() {
        this.cancel && this.cancel();
        this.closeModal();
    }

    closeModal() {
        this.visible = false;
        this.$emit('close', false);
    }
    mounted() {
        this.getList();
    }
    // * API:获取无效标识集列表
    async getList() {
        let { data } = await DataAuditApi.InvalidIdentifiersList();
        if (data) {
            this.dataSource = { 无效标识集: data };
        }
    }
    async addInvalid() {
        await auditAddInvalidModal('新增');
        await this.getList();
    }
    async deleteInvalid() {
        //删除前询问
        let res = await Toast.confirm();
        if (!res) return;
        let gridOptions: any = this.gridOptions;
        let selectRows: AuditRuleViewVOI.FormDataI[] = gridOptions.api.getSelectedRows();
        let ids: any[] = selectRows.map(item => item.id);
        await this.delete(ids);
        await this.getList();
    }
    async delete(ids: number[]) {
        let { code } = await DataAuditApi.InvalidIdentifiersDelete({ ids });
        if (code === 0) {
            Toast.success('删除成功');
        }
    }

    render(h) {
        return (
            <Modal
                title="无效标识集"
                width="1000"
                class="wqms-modal-fix-height"
                v-model={this.visible}
                mask-closable={false}
                on-on-cancel={this.close}
                footer-hide={true}
            >
                <div class={bem()}>
                    <div>
                        <Button class={bem('add')} on-click={() => this.addInvalid()}>
                            添加
                        </Button>
                        <Button class={bem('delete')} onClick={this.deleteInvalid}>
                            删除
                        </Button>
                    </div>
                    <AgGridVueCustomTsx
                        class={bem('grid')}
                        gridOptions={this.gridOptions}
                        columnDefs={this.columnDefs}
                        rowData={this.dataSource[this.currentTab]}
                        enableServerSideSorting={false}
                        checkBoxShow={true}
                        pageShow={false}
                    />
                </div>
            </Modal>
        );
    }
}

export default function alertAuditRuleViewModal(): Promise<boolean> {
    return new Promise((resolve, reject) => {
        modalFactory<AuditRuleViewVOI.PropsI>(AuditRuleViewModal)({
            saveSuccess() {
                resolve(true);
            },
            cancel() {
                resolve(false);
            },
        });
    });
}
